import React, { useState, useEffect, useContext } from "react";
import getProfileLabel from "../genericFunctions/getProfileLabel";
import { AuthContext } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { KeyboardDatePicker } from "@material-ui/pickers";
import "date-fns";
import Grid from "@material-ui/core/Grid";

import DateFnsUtils from "@date-io/date-fns";

const ExperienceItem = (props) => {
  const updateExperience = props.updateExperience;
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const [editing, setEditing] = useState(false);
  const [experience, setExperience] = useState({
    _id: null,
    name: "",
    description: "",
    tools: "",
    fromDate: null,
    toDate: null,
    currentJob: false,
    role: "",
  });

  const [currentJob, setCurrentJob] = useState(false);

  const onChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setExperience({ ...experience, [name]: value });
  };

  useEffect(() => {
    if (!authContext.isAuthenticated) {
      history.push("/login");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const validateExperience = () => {
    if (
      experience.name === "" ||
      experience.description === "" ||
      experience.tools === "" ||
      experience.fromDate === null ||
      ((experience.toDate === null ||
        isNaN(Date.parse(experience.toDate)) ||
        new Date(experience.fromDate) > new Date(experience.toDate)) &&
        currentJob === false) ||
      experience.role === "" ||
      isNaN(Date.parse(experience.fromDate))
    ) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (editing) {
      setCurrentJob(props.experience.currentJob);
      setExperience({
        _id: props.experience._id,
        name: props.experience.name,
        role: props.experience.role,
        description: props.experience.description,
        tools: props.experience.tools,
        fromDate:
          props.experience.fromDate !== null ? props.experience.fromDate : null,
        toDate:
          props.experience.toDate !== null ? props.experience.toDate : null,
        currentJob: props.experience.currentJob,
      });
      //validateExperience();
    }
  }, [editing]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (experience.currentJob) {
      setExperience({ ...experience, toDate: null });
    } else if (
      (!experience.currentJob && experience.toDate === null) ||
      experience.toDate.length <= 0
    ) {
      setExperience({ ...experience });
    }
  }, [experience.currentJob]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Paper
      elevation={1}
      style={{
        margin: "10px 0px",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        minWidth: "45%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #e1e1e1",
          padding: "5px 5px 5px 0px",
          marginBottom: "15px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h6
            style={{
              margin: "0",
              marginRight: "10px",
            }}
          >
            {editing
              ? `Editing (${props.experience.name})`
              : props.experience.name}
          </h6>
          {!editing && (
            <p
              style={{
                fontStyle: "italic",
                fontWeight: "lighter",
                color: "dark-grey",
                fontSize: "90%",
                margin: "5px 0px 0px 0px",
              }}
            >
              {`${props.experience.role} 
              (${
                props.experience.fromDate !== null
                  ? props.experience.fromDate.slice(0, 7)
                  : getProfileLabel(props.profileLanguage, "missingDate")
              } 
              - 
              ${
                props.experience.toDate !== null
                  ? props.experience.toDate.slice(0, 7)
                  : getProfileLabel(props.profileLanguage, "present")
              })`}
            </p>
          )}
        </div>
        <div style={{ display: "flex" }}>
          {!editing && (
            <IconButton
              variant="outlined"
              color="primary"
              style={{ justifySelf: "flex-end" }}
              onClick={() => {
                setEditing(true);
              }}
            >
              <EditIcon />
            </IconButton>
          )}
          {editing && (
            <IconButton
              variant="outlined"
              color="primary"
              style={{ justifySelf: "flex-end" }}
              onClick={() => setEditing(false)}
            >
              <CloseIcon />
            </IconButton>
          )}
        </div>
      </div>
      {!editing && (
        <div>
          <p style={{ whiteSpace: "pre-wrap" }}>
            {props.experience.description}
          </p>
          <p style={{ fontWeight: "bold", margin: "0px" }}>{getProfileLabel(props.profileLanguage, "tools")}</p>
          <p>{props.experience.tools}</p>
        </div>
      )}
      {editing && (
        <div
          elevation={1}
          style={{
            margin: "5px 0px",
            display: "flex",
            flexDirection: "column",
            minWidth: "45%",
          }}
        >
          <form
            onSubmit={(e) => {
              setEditing(false);
              updateExperience(e, experience);
              console.log(experience);
            }}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <TextField
              type="text"
              name="name"
              label="Company"
              value={experience.name}
              onChange={onChange}
              style={{ margin: "5px 0px" }}
              variant="outlined"
            />
            <TextField
              type="text"
              name="role"
              label="Role"
              value={experience.role}
              onChange={onChange}
              style={{ margin: "5px 0px" }}
              variant="outlined"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={currentJob}
                  onClick={() => {
                    setCurrentJob(!currentJob);
                  }}
                  onChange={onChange}
                  name="currentJob"
                  value={currentJob}
                  color="primary"
                />
              }
              label="Current job"
              style={{ width: "30.5%", padding: "10px 2px 5px" }}
            />
            <div style={{ display: "flex" }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-between">
                  <KeyboardDatePicker
                    inputVariant="outlined"
                    disableToolbar
                    variant="inline"
                    format="MM/yyyy"
                    views={["year", "month"]}
                    margin="normal"
                    id="date-picker-inline"
                    InputLabelProps={{ shrink: true }}
                    label="From date"
                    value={experience.fromDate}
                    onChange={(date) => {
                      setExperience({ ...experience, fromDate: date });
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                  {!experience.currentJob && (
                    <KeyboardDatePicker
                      inputVariant="outlined"
                      disableToolbar
                      variant="inline"
                      format="MM/yyyy"
                      views={["year", "month"]}
                      margin="normal"
                      id="date-picker-inline"
                      InputLabelProps={{ shrink: true }}
                      label="To date"
                      value={experience.toDate}
                      onChange={(date) => {
                        setExperience({ ...experience, toDate: date });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  )}
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
            <TextField
              type="text"
              name="tools"
              label="Tools"
              value={experience.tools}
              onChange={onChange}
              style={{ margin: "5px 0px" }}
              variant="outlined"
            />
            <TextField
              type="text"
              name="description"
              label="Description"
              value={experience.description}
              onChange={onChange}
              multiline
              rows={4}
              variant="outlined"
              style={{ whiteSpace: "pre-wrap", margin: "5px 0px" }}
            />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex", marginTop: "10px" }}>
                <Button
                  disabled={!validateExperience()}
                  type="submit"
                  variant="outlined"
                  color="primary"
                  style={{ marginRight: "10px" }}
                >
                  Save
                </Button>
                <Button
                  type="button"
                  variant="outlined"
                  color="secondary"
                  onClick={() => setEditing(false)}
                >
                  Cancel
                </Button>
              </div>
              <IconButton
                variant="outlined"
                color="secondary"
                style={{ justifySelf: "flex-end" }}
                onClick={() => props.removeExperience(props.experience)}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          </form>
        </div>
      )}
    </Paper>
  );
};

export default ExperienceItem;
